import { Navigate } from "react-router-dom";
import { IRoute } from "./IRoute";
import useUserAccount from "../hooks/userAccountHook";
import useAuth from "../hooks/authHook";

export const PrivateRoute = (props: IRoute): JSX.Element => {
  const { getAccount } = useUserAccount();
  const authed = getAccount().isAuthenticated;
  const { getPathToSignIn } = useAuth();

  const { children } = props;

  return (
    <>
      {authed ? (
        <>
          {children}
        </>
      ) : (
        <Navigate to={getPathToSignIn()} replace />
      )}
    </>
  );
}

export default PrivateRoute;


